import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  BundlePdpResponse,
  PersonalizedFertilizerPdpResponse,
  SuggestedAddonsPageResponse,
} from "@halm-club/halm-shared";

type BundlePdpQueryArgs = {
  productId: string;
  queryString: string;
};

type PersonalizedFertilizerPdpQueryArgs = {
  queryString: string;
};

type SuggestedAddonsQueryArgs = {
  queryString: string;
};

export const backendApi = createApi({
  reducerPath: "backendApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.halm.club/api/v2/",
    // baseUrl: "http://localhost:7071/api/v2",
  }),
  endpoints: (builder) => ({
    getBundlePdp: builder.query<BundlePdpResponse, BundlePdpQueryArgs>({
      query: ({ productId, queryString }) => {
        const querySuffix = queryString ? `?${queryString}` : "";

        return `shopify/product-details-pages/bundle/${encodeURIComponent(
          productId,
        )}${querySuffix}`;
      },
    }),
    getPersonalizedFertilizerPdp: builder.query<
      PersonalizedFertilizerPdpResponse,
      PersonalizedFertilizerPdpQueryArgs
    >({
      query: ({ queryString }) => {
        const querySuffix = queryString ? `?${queryString}` : "";

        return `shopify/product-details-pages/personalized-fertilizer${querySuffix}`;
      },
    }),
    getSuggestedAddons: builder.query<
      SuggestedAddonsPageResponse,
      SuggestedAddonsQueryArgs
    >({
      query: ({ queryString }) => {
        const querySuffix = queryString ? `?${queryString}` : "";

        return `shopify/product-details-pages/suggested-addons${querySuffix}`;
      },
    }),
  }),
});

export const {
  useGetBundlePdpQuery,
  useGetPersonalizedFertilizerPdpQuery,
  useGetSuggestedAddonsQuery,
} = backendApi;
